import { defineComponent as _defineComponent } from 'vue'
import { truncate } from '@/utils/string';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextTruncatedChip',
  props: {
    text: null,
    maxLength: { default: 45 },
    color: { default: undefined },
    label: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    prependIcon: { default: undefined },
    prependIconColor: { default: undefined },
    closable: { type: Boolean, default: true }
  },
  emits: ["click:close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click:close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { text: string, maxLength: number, color: string, label: boolean, disabled: boolean, prependIcon: string, prependIconColor: string, closable: boolean };





return { __sfc: true,props, emits, truncate }
}

})